import React, { useEffect, useState } from 'react';
import SimpleBarChart from './charts/SimpleBarChart';

function ConsumptionSummaryChart({ type, start, end, isCustom = false }) {
  const [stats, setStats] = useState({
    selected: 0,
    previous: 0,
  });

  useEffect(() => {
    const endSelected = end ? new Date(end) : new Date();
    const startSelected = start
      ? new Date(start)
      : new Date(endSelected.getTime() - 7 * 24 * 60 * 60 * 1000);

    const fmt = d => d.toISOString().slice(0, 10);

    if (isCustom) {
      fetch(
        `/api/consumption-stats-range.php?start=${fmt(startSelected)}&end=${fmt(endSelected)}`
      )
        .then(res => res.json())
        .then(selRes => {
          const selAvg =
            type === 'magnetite'
              ? selRes.magnetite_consumption || 0
              : selRes.flocculant_consumption || 0;
          setStats({ selected: selAvg, previous: 0 });
        })
        .catch(() => setStats({ selected: 0, previous: 0 }));
    } else {
      const startPrev = new Date(startSelected.getTime() - 7 * 24 * 60 * 60 * 1000);
      const endPrev = new Date(startSelected.getTime());
      Promise.all([
        fetch(
          `/api/consumption-stats-range.php?start=${fmt(startPrev)}&end=${fmt(endPrev)}`
        ).then(res => res.json()),
        fetch(
          `/api/consumption-stats-range.php?start=${fmt(startSelected)}&end=${fmt(endSelected)}`
        ).then(res => res.json()),
      ])
        .then(([prevRes, selRes]) => {
          const selAvg =
            type === 'magnetite'
              ? selRes.magnetite_consumption || 0
              : selRes.flocculant_consumption || 0;
          const prevAvg =
            type === 'magnetite'
              ? prevRes.magnetite_consumption || 0
              : prevRes.flocculant_consumption || 0;
          setStats({
            selected: selAvg,
            previous: prevAvg,
          });
        })
        .catch(() => {
          setStats({
            selected: 0,
            previous: 0,
          });
        });
    }
  }, [type, start, end, isCustom]);

  const calcStep = val => {
    if (val === 0) return 1;
    const rough = val / 5;
    const pow = Math.pow(10, Math.floor(Math.log10(rough)));
    const mults = [1, 2, 5, 10];
    for (const m of mults) {
      if (rough <= m * pow) {
        return m * pow;
      }
    }
    return 10 * pow;
  };

  const target = type === 'magnetite' ? 0.5 : 10;
  const maxVal = Math.max(
    stats.selected,
    isCustom ? target : Math.max(stats.previous, target)
  );
  const step = calcStep(maxVal);
  const tickCount = Math.ceil(maxVal / step);
  const ticks = Array.from({ length: tickCount + 1 }, (_, i) => +(i * step).toFixed(2));
  const maxAxis = tickCount > 0 ? ticks[ticks.length - 1] : step;

  return (
    <SimpleBarChart
      height={160}
      data={
        isCustom
          ? [
              {
                label: 'Custom date',
                value: stats.selected,
                color: '#22c55e',
                display: stats.selected.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Target',
                value: target,
                color: '#3b82f6',
                display: target.toString(),
                valueInside: true,
              },
            ]
          : [
              {
                label: 'Selected Week',
                value: stats.selected,
                color: '#22c55e',
                display: stats.selected.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Previous Week',
                value: stats.previous,
                color: '#22c55e',
                display: stats.previous.toFixed(2),
                valueInside: true,
              },
              {
                label: 'Target',
                value: target,
                color: '#3b82f6',
                display: target.toString(),
                valueInside: true,
              },
            ]
      }
      max={maxAxis}
      ticks={ticks}
      valueClass="text-sm font-bold"
      labelFontSize={14}
      labelBold
    />
  );
}

export default ConsumptionSummaryChart;
